@for (toast of toasts$ | async; track toast.id) {
  <app-toast
    [toast]="toast"
    (dismissed)="toastService.dismiss($event)"
    (acted)="toastService.dismiss($event)"
  />
}
